import {createAsyncThunk} from '@reduxjs/toolkit';

export const updateInitialState = createAsyncThunk('formConfig/update', initialState => initialState);

export const updateFormStep = createAsyncThunk('formStep/update', direction => direction);
